<template>
	<div class="PageGroupReset">
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'PageGroupReset',
	destroyed(){
		this.$store.commit('RESET_EDITUSER');
		this.$store.commit('RESET_ACTIVE_FIELD');
		this.$store.commit('RESET_PRESENTATIONID');
		this.$store.commit('UNSET_PRESENTATION');
		this.$store.commit('UNSET_ADDABLECHARTS');
		this.$store.commit('UNSET_CHARTS');
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/PageGroupReset.vue